export default __webpack_public_path__ + "static/char-thumb-45-a9e0c406a49afb78d04f575cc70fd0a4.png";